import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

if (!customElements.get('main-blog-nav')) {
  class MainBlogNav extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      prevEl: '.main-blog__nav-prev',
      nextEl: '.main-blog__nav-next',
    };
    slider;
    settings = {
      slidesPerView: 'auto',
      spaceBetween: 35,
      arrows: true,
      navigation: {
        prevEl: this.selectors.prevEl,
        nextEl: this.selectors.nextEl
      }
    };

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Init.
     *
     * @returns {Void}
     */
    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
    }
  }
  customElements.define('main-blog-nav', MainBlogNav);
}
